export const GET_BANK_ACCOUNTS = `
query($profileId: ID, $start: Int, $limit: Int) {
    accounts(
      where: { profileId: $profileId }
      start: $start
      limit: $limit
      sort: "created_at:desc"
    ) {
      id
      bankName
      accountName
      accountNumber
      address
      swiftCode
    }
  }
`

export const GET_ACCOUNTS = `
query($accountId: ID) {
  accounts(where: { id: $accountId }) {
    accountName
    id
    address
    swiftCode
    bankName
    accountNumber
    profileId {
      id
    }
  }
}
`;